export default {
    AsterLead: {
        getdata: '',
        template_name:''
    }
};